export default [
	{
		tenantId: 'b16e03a6-17bb-4f0c-b316-9ec017e51d5a',
		labels: {
			industry: 'Industry',
			industryRequired: 'Industry is required',
			selectIndustry: 'Select your industry',
			educationSectionButton: 'Education',
			educationSectionHeader: 'Education',
			educationSectionDescription: 'For increased credibility, tell us about your qualifications.',
			educationSectionPrimaryQualification: 'Primary Qualification',
			educationSectionCollege: 'College',
			educationSectionDateQualified: 'Date Qualified',
			aboutSectionFileUploadTitle: 'Do you have Professional Indemnity Insurance?',
			aboutSectionFileUploadInputLabel: 'Upload a new professional indemnity doc',
			professionalDashboardLandingActionCardTitle: 'When are you available to Locum?',
			professionalDashboardLandingActionCardButton: 'Set your availability',
			upcomingBookingsTitle: 'Upcoming Bookings',
			companyName: 'Practice Name',
			companyNumber: 'Practice Number',
			companyContactNumber: 'Practice Contact Number',
			companyEmailAddress: 'Practice Email Address',
			companyOperations: 'Practice operations',
			companyAddress: 'Practice Address',
			companyAboutSectionButton: 'about practice',
			companyAboutSectionTitle: 'About the practice',
			companyAboutSectionPicturesTitle: 'Upload pictures of your practice',
			companyAboutSectionBioPlaceholder: 'Tell us more about your practice, your support team and your working environment.',
			companyAddressSectionDescription: 'Make it easy for a locum to find you, where are you located?',
			companyOperationsSectionInsuranceQuestion: 'Does your Malpractice Insurance cover Locums working in your practice?',
			companyOperationsSectionSystemsUsed: 'Tell us about any specific software/programs that your Locum needs to work with',
			companyProfileUnlockButton: 'Unlock your practice profile',
			companyCompleteProfileCompleteButton: 'Find locums',
			companyCompleteProfileCompleteDescription: 'Your practice is now active.',
			findProfessionals: 'Find Locums',
			meetOurProfessionals: 'Meet our Locums',
			moreProfessionals: 'More Locums',
			switchOrAddHint: 'Switch or Add Practice',
			addCompany: 'Add Practice',
			professionalDirectory: 'Locum Directory',
			companyDashboardLandingActionCardTitle: 'Do you need a locum for your practice?',
			companyDashboardLandingActionCardButton: 'Find a locum',
			companyDashboardLandingActionCardButton2: 'Set an offer',
			companyDashboardLandingActionCardButton3: 'Browse Locums',
			companyProfessionalApplicationsReceivedTitle: 'Locum Applications',
			findAProfessional: 'Find a locum',
			companyUserManagementPageDescription: 'Invite a team member to join your Practice',
			bookingRequestsSent: 'Booking Requests Sent',
			bookingFlowSearchResultCountProfessionDescriptor: 'locums',
			bookingFlowBookingSummaryTotalTitle: 'Total Estimated Locum Fee',
			bookingFlowSendBookingRequest: 'Send Booking Request',
			bookingFlowBookingSummaryTitle: 'Booking Summary',
			bookingFlowBookingSummaryRemainders: 'Do you want to book another locum for the same dates?',
			ratesSectionHourlyRateText: 'Enter your desired HOURLY Locum rate. Should you need guidance, see our average rates',
			ratesSectionHourlyRateLinkText: 'here',
			ratesSectionHourlyRateLink: 'https://www.locumbase.com/rate-card',
			ratesSectionFixedRateText:
				'Rates for your selected industry are standard across the platform. This ensures fair trading of your time and affordability to the booking practice.',
			locumLevel1Top: 'You are not yet visible to practices',
			locumLevel1Bottom: 'Unlock profile, your professional information will be verified soon',
			locumLevel2Top: 'Keep going to view and accept offers online',
			locumLevel2Bottom: 'Complete your profile to increase visibility',
			locumProfileUnlockButton: 'Unlock Your Star Profile',
			locumCompleteProfileCompleteButton: 'Find Offers',
		},
	},
	{
		tenantId: '3f5a9c8a-4a78-4723-a9bd-3f43b18fe5be',
		labels: {
			industry: 'Primary Area of Expertise',
			industryRequired: 'Primary Area of Expertise is required',
			selectIndustry: 'Select your primary area of expertise',
			selectProfession: 'Your primary role?',
			uploadIdDocument: 'Upload your most recent ID document',
			uploadIdDocumentError: 'Please upload your most recent ID document',
			experienceStartDate: 'When did you start in hospitality?',
			additionalSkills: 'Additional Skills',
			driversLicence: 'Drivers Licence',
			buildingLabel: 'Physical Location',
			buildingHint: 'Shopping Mall, Building Name, etc.',
			opsSystemsHeading: 'Ops Systems',
			systemsUsedDisplayName: 'Ops Systems',
			educationSectionButton: 'Training & Qualifications',
			educationSectionHeader: 'Training & Qualifications',
			educationSectionDescription: 'For increased credibility, tell us about your qualifications.',
			educationSectionPrimaryQualification: 'Primary training & skill development/Qualification',
			educationSectionCollege: 'Institution',
			educationSectionDateQualified: 'Date formal training completed',
			aboutSectionFileUploadTitle: 'Do you have a valid Driver’s Licence?',
			aboutSectionFileUploadInputLabel: 'Upload copy of your Driver’s Licence',
			professionalDashboardLandingActionCardTitle: 'When are you free to work?',
			professionalDashboardLandingActionCardButton: 'Set your availability',
			upcomingBookingsTitle: 'Upcoming Shifts',
			companyName: 'Venue Name',
			companyNumber: 'Your Website',
			companyContactNumber: 'Additional Contact Number',
			companyEmailAddress: 'Manager Email Address',
			companyOperations: 'Operations',
			companyAddress: 'Address',
			companyAboutSectionButton: 'about venue',
			companyAboutSectionTitle: 'About Venue',
			companyAboutSectionPicturesTitle: 'Upload pictures of your venue',
			companyAboutSectionBioPlaceholder: 'Tell us more about your place, your team, your vibe, your menu, your patrons. Tell us everything!',
			companyAddressSectionDescription: 'Make it easy for a shift seeker to find you, where are you located?',
			companyOperationsSectionInsuranceQuestion: 'Does your business insurance cover shift workers in your establishment?',
			companyOperationsSectionSystemsUsed: 'Do you use Yoco, GAAP, something else…',
			companyProfileUnlockButton: 'Unlock your venue profile',
			companyCompleteProfileCompleteButton: 'Find your team',
			companyCompleteProfileCompleteDescription: 'Your profile is active.',
			findProfessionals: 'Find Shift Seekers',
			meetOurProfessionals: 'Featured Shift Seekers',
			moreProfessionals: 'More Shift Seekers',
			switchOrAddHint: 'Switch or Add Venue',
			addCompany: 'Add Venue',
			professionalDirectory: 'Featured Shift Seekers',
			companyDashboardLandingActionCardTitle: 'Need to fill a shift?',
			companyDashboardLandingActionCardButton1: 'Find the ONE',
			companyDashboardLandingActionCardButton2: 'Post a Job',
			companyDashboardLandingActionCardButton3: 'Browse All',
			companyProfessionalApplicationsReceivedTitle: 'Shift Applications',
			findAProfessional: 'Find a shift seeker',
			companyUserManagementPageDescription: 'Invite a team member to join your Venue',
			bookingRequestsSent: 'Shift Requests Sent',
			bookingFlowSearchResultCountProfessionDescriptor: 'seekers',
			bookingFlowBookingSummaryTotalTitle: 'Total Estimated Shift Fee',
			bookingFlowSendBookingRequest: 'Send Shift Request',
			bookingFlowBookingSummaryTitle: 'Shift Summary',
			bookingFlowBookingSummaryRemainders: 'Do you want to book another shift seeker for the same dates?',
			bookingFlowMinRatePerHour: 'Minimum rate per hour',
			bookingFlowTotalHours: 'Total hours for this booking',
			bookingFlowApproxEarnings: 'Approx total earnings for this booking',
			ratesSectionHourlyRateText: 'Be sure to check the guidelines on rates. Chat to others who currently have this job, and be reasonable for the shift you wish to fill',
			ratesSectionHourlyRateLinkText: 'Check Guideline',
			ratesSectionHourlyRateLink: 'https://www.zenzishift.com/rates-guidelines',
			ratesSectionFixedRateText: 'Be sure to check the guidelines on rates. Chat to others who currently have this job, and be reasonable for the shift you wish to fill',
			ratesMinimumError: 'Rate cannot be below R35 per hour',
			educationNoFormalTraining: 'I don’t have formal training.',
			educationLearnedOnTheJob: 'I have experience and learned on the job',
			typeOfEstablishment: 'Type of Establishment',
			typeOfEstablishmentRequired: 'Type of Establishment is required',
			skillsFilterLabel: 'Additional Skills',
			skillsFilterOptionalLabel: 'Additional Skills (Optional)',
			establishmentTypeDisplayName: 'Type of Establishment',
			locumLevel1Top: 'You are not yet visible to Venues',
			locumLevel1Bottom: 'Your information will be verified soon',
			locumLevel2Top: 'Keep going to view and accept offers online',
			locumLevel2Bottom: 'Check out your Dashboard now!',
			locumProfileUnlockButton: 'Unlock Your Star Profile',
			locumCompleteProfileCompleteButton: 'Set Availability',
		},
	},
	{
		tenantId: '76081da2-5fdd-47b0-8caf-2c337ea3bf9f',
		labels: {
			industry: 'Primary Area of Expertise',
			industryRequired: 'Primary Area of Expertise is required',
			selectIndustry: 'Select your primary area of expertise',
			selectProfession: 'Your primary role?',
			uploadIdDocument: 'Upload your most recent ID document',
			uploadIdDocumentError: 'Please upload your most recent ID document',
			experienceStartDate: 'When did you start in hospitality?',
			additionalSkills: 'Additional Skills',
			driversLicence: 'Drivers Licence',
			buildingLabel: 'Physical Location',
			buildingHint: 'Shopping Mall, Building Name, etc.',
			opsSystemsHeading: 'Ops Systems',
			systemsUsedDisplayName: 'Ops Systems',
			educationSectionButton: 'Training & Qualifications',
			educationSectionHeader: 'Training & Qualifications',
			educationSectionDescription: 'For increased credibility, tell us about your qualifications.',
			educationSectionPrimaryQualification: 'Primary training & skill development/Qualification',
			educationSectionCollege: 'Institution',
			educationSectionDateQualified: 'Date formal training completed',
			aboutSectionFileUploadTitle: 'Do you have a valid Driver’s Licence?',
			aboutSectionFileUploadInputLabel: 'Upload copy of your Driver’s Licence',
			professionalDashboardLandingActionCardTitle: 'When are you free to work?',
			professionalDashboardLandingActionCardButton: 'Set your availability',
			upcomingBookingsTitle: 'Upcoming Shifts',
			companyName: 'Venue Name',
			companyNumber: 'Your Website',
			companyContactNumber: 'Additional Contact Number',
			companyEmailAddress: 'Manager Email Address',
			companyOperations: 'Operations',
			companyAddress: 'Address',
			companyAboutSectionButton: 'about venue',
			companyAboutSectionTitle: 'About Venue',
			companyAboutSectionPicturesTitle: 'Upload pictures of your venue',
			companyAboutSectionBioPlaceholder: 'Tell us more about your place, your team, your vibe, your menu, your patrons. Tell us everything!',
			companyAddressSectionDescription: 'Make it easy for a shift seeker to find you, where are you located?',
			companyOperationsSectionInsuranceQuestion: 'Does your business insurance cover shift workers in your establishment?',
			companyOperationsSectionSystemsUsed: 'Do you use Yoco, GAAP, something else…',
			companyProfileUnlockButton: 'Unlock your venue profile',
			companyCompleteProfileCompleteButton: 'Find your team',
			companyCompleteProfileCompleteDescription: 'Your profile is active.',
			findProfessionals: 'Find Shift Seekers',
			meetOurProfessionals: 'Featured Shift Seekers',
			moreProfessionals: 'More Shift Seekers',
			switchOrAddHint: 'Switch or Add Venue',
			addCompany: 'Add Venue',
			professionalDirectory: 'Featured Shift Seekers',
			companyDashboardLandingActionCardTitle: 'Need to fill a shift?',
			companyDashboardLandingActionCardButton1: 'Find the ONE',
			companyDashboardLandingActionCardButton2: 'Post a Job',
			companyDashboardLandingActionCardButton3: 'Browse All',
			companyProfessionalApplicationsReceivedTitle: 'Shift Applications',
			findAProfessional: 'Find a shift seeker',
			companyUserManagementPageDescription: 'Invite a team member to join your Venue',
			bookingRequestsSent: 'Shift Requests Sent',
			bookingFlowSearchResultCountProfessionDescriptor: 'seekers',
			bookingFlowBookingSummaryTotalTitle: 'Total Estimated Shift Fee',
			bookingFlowSendBookingRequest: 'Send Shift Request',
			bookingFlowBookingSummaryTitle: 'Shift Summary',
			bookingFlowBookingSummaryRemainders: 'Do you want to book another shift seeker for the same dates?',
			bookingFlowMinRatePerHour: 'Minimum rate per hour',
			bookingFlowTotalHours: 'Total hours for this booking',
			bookingFlowApproxEarnings: 'Approx total earnings for this booking',
			ratesSectionHourlyRateText: 'Be sure to check the guidelines on rates. Chat to others who currently have this job, and be reasonable for the shift you wish to fill',
			ratesSectionHourlyRateLinkText: 'Check Guideline',
			ratesSectionHourlyRateLink: 'https://www.zenzishift.com/rates-guidelines',
			ratesSectionFixedRateText: 'Be sure to check the guidelines on rates. Chat to others who currently have this job, and be reasonable for the shift you wish to fill',
			ratesMinimumError: 'Rate cannot be below R35 per hour',
			educationNoFormalTraining: 'I don’t have formal training.',
			educationLearnedOnTheJob: 'I have experience and learned on the job',
			typeOfEstablishment: 'Type of Establishment',
			typeOfEstablishmentRequired: 'Type of Establishment is required',
			skillsFilterLabel: 'Additional Skills',
			skillsFilterOptionalLabel: 'Additional Skills (Optional)',
			establishmentTypeDisplayName: 'Type of Establishment',
			locumLevel1Top: 'You are not yet visible to Venues',
			locumLevel1Bottom: 'Your information will be verified soon',
			locumLevel2Top: 'Keep going to view and accept offers online',
			locumLevel2Bottom: 'Check out your Dashboard now!',
			locumProfileUnlockButton: 'Unlock Your Star Profile',
			locumCompleteProfileCompleteButton: 'Set Availability',
		},
	},
	{
		tenantId: 'e4f84ffd-cc7d-47d8-ad04-983e73031ba2',
		labels: {
			industry: 'Industry',
			industryRequired: 'Industry is required',
			selectIndustry: 'Select your industry',
			educationSectionButton: 'Education',
			educationSectionHeader: 'Education',
			educationSectionDescription: 'For increased credibility, tell us about your qualifications.',
			educationSectionPrimaryQualification: 'Primary Qualification',
			educationSectionCollege: 'College',
			educationSectionDateQualified: 'Date Qualified',
			aboutSectionFileUploadTitle: 'Do you have Professional Indemnity Insurance?',
			aboutSectionFileUploadInputLabel: 'Upload a new professional indemnity doc',
			professionalDashboardLandingActionCardTitle: 'When are you available to work?',
			professionalDashboardLandingActionCardButton: 'Set your availability',
			upcomingBookingsTitle: 'Upcoming Bookings',
			companyName: 'Hospital Name',
			companyNumber: 'Business Registration Number',
			companyContactNumber: 'Hospital Contact Number',
			companyEmailAddress: 'Additional Email Address',
			companyOperations: 'Operations',
			companyAddress: 'Physical address',
			companyAboutSectionButton: 'about',
			companyAboutSectionTitle: 'About',
			companyAboutSectionPicturesTitle: 'Upload pictures of your team',
			companyAboutSectionBioPlaceholder: 'Tell us more about your team and your working environment.',
			companyAddressSectionDescription: 'Where are you located?',
			companyOperationsSectionInsuranceQuestion: 'Does your Malpractice Insurance cover nurses working in your unit?',
			companyOperationsSectionSystemsUsed: 'Tell us about any specific software/programs that your nurses needs to work with',
			companyProfileUnlockButton: 'Unlock your profile',
			companyCompleteProfileCompleteButton: 'Find nurses',
			companyCompleteProfileCompleteDescription: 'Your profile is now active.',
			findProfessionals: 'Find nurses',
			meetOurProfessionals: 'Meet our Nurses',
			moreProfessionals: 'More Nurses',
			switchOrAddHint: 'Switch or Add Unit',
			addCompany: 'Add Unit',
			professionalDirectory: 'Team Directory',
			companyDashboardLandingActionCardTitle: 'Do you need a nurse for your unit?',
			companyDashboardLandingActionCardButton: 'Find a nurse',
			companyDashboardLandingActionCardButton2: 'Set an offer',
			companyDashboardLandingActionCardButton3: 'Browse Nurses',
			companyProfessionalApplicationsReceivedTitle: 'Nurse Applications',
			findAProfessional: 'Find a nurse',
			companyUserManagementPageDescription: 'Invite a team member to join your hospital',
			bookingRequestsSent: 'Booking Requests Sent',
			bookingFlowSearchResultCountProfessionDescriptor: 'nurses',
			bookingFlowBookingSummaryTotalTitle: 'Total Estimated Nurse Fee',
			bookingFlowSendBookingRequest: 'Send Booking Request',
			bookingFlowBookingSummaryTitle: 'Booking Summary',
			bookingFlowBookingSummaryRemainders: 'Do you want to book another nurse for the same dates?',
			ratesSectionHourlyRateText: 'Enter your desired HOURLY Locum rate. Should you need guidance, see our average rates',
			ratesSectionHourlyRateLinkText: 'here',
			ratesSectionHourlyRateLink: 'https://www.locumbase.com/rate-card',
			ratesSectionFixedRateText:
				'Rates for your selected industry are standard across the platform. This ensures fair trading of your time and affordability to the booking practice.',
			locumLevel1Top: 'You are not yet visible to practices',
			locumLevel1Bottom: 'Unlock profile, your professional information will be verified soon',
			locumLevel2Top: 'Keep going to view and accept offers online',
			locumLevel2Bottom: 'Complete your profile to increase visibility',
			locumProfileUnlockButton: 'Unlock Your Star Profile',
			locumCompleteProfileCompleteButton: 'Find Offers',
		},
	},
];
